export const LOGIN_REDIRECT_ERROR_MESSAGE =
  'Login Redirect Failed, Please check if you have whitelisted login.microsoft.com in your antivirus or plugin'
